import React from "react";

import ProgramSpecs from "../../components/ProgramSpecs/ProgramSpecs";
import Goals from "../../components/Goals/Goals";
import ProgramBanner from "../../components/ProgramBanner/ProgramBanner";
import LearningModule from "../../components/LearningModule/LearningModule";

const ProgIntroFinGestDepor = () => {
    const programs = [
        {
            key: 'FORMATO',
            title: 'Formato',
            content: '100% online, con clases virtuales semanales en vivo',
        },
        {
            key: 'ACCESO_CV',
            title: 'Acceso al campus virtual',
            content: 'las 24 horas',
        },
        {
            key: 'IDIOMA',
            title: 'Idioma',
            content: 'español',
        },
        {
            key: 'DURACION',
            title: 'Duración',
            content: '2 meses',
        },
        {
            key: 'FECHA_INICIO',
            title: 'Fecha de inicio',
            content: 'a definir',
        },
        {
            key: 'DIA_Y_HORA',
            title: "Día y horario",
            content: 'TBD (horario de España)' ,
        },
        {
            key: 'PROYECTOS',
            title: 'Proyectos',
            content: 'prácticos en clubes de fútbol',
        },
        {
            key: 'CASOS',
            title: 'Casos',
            content: 'de estudio reales',
        }
    ];

    const goals = [
        {
            key: 'FINANZAS',
            content: 'Desarrollar independencia financiera, proporcionando las herramientas necesarias para gestionar los ingresos de manera eficiente y responsable.',
        },
        {
            key: 'RIESGOS',
            content: 'Identificar y comprender los principales riesgos financieros y legales, para proteger y asegurar el futuro económico del deportista.',
        },
        {
            key: 'HERRAMIENTAS',
            content: "Aprender a diseñar una planificación financiera a largo plazo, que permita a los deportistas continuar generando ingresos de forma sostenible tras el retiro.",
        }
    ];

    const modules = [
        {
            moduleTitle: 'MÓDULO I',
            title: 'Finanzas: conceptos clave',
            content: [
                'Comprender los objetivos de una inversión y explorar estrategias para aumentar los retornos mientras se mitigan los riesgos.'
            ]
        },
        {
            moduleTitle: 'MÓDULO II',
            title: 'Consumo, ahorro e inversión',
            content: [
                'Analizar el valor del dinero en el tiempo y las tasas de interés.',
                'Adquirir herramientas prácticas para tomar decisiones financieras informadas.'
            ]
        },
        {
            moduleTitle: 'MÓDULO III',
            title: 'Clase integradora: el valor de un futbolista',
            content: [
                'Examinar el impacto del consumo en la capacidad de generar ingresos futuros a través de un enfoque práctico.'
            ]
        },
        {
            moduleTitle: 'MÓDULO IV',
            title: 'Mentalidad, inversión y negocios',
            content: [
                'Reconocer la importancia del componente psicológico en la toma de decisiones financieras.',
                'Estudiar casos e historias exitosas de futbolistas que se han convertido en empresarios.'
            ]
        },
        {
            moduleTitle: 'MÓDULO V',
            title: 'Renta activa vs. renta pasiva: retorno',
            content: [
                'Conocer los diferentes tipos de inversiones y activos disponibles.'
            ]
        },
        {
            moduleTitle: 'MÓDULO VI',
            title: 'Derecho y planificación',
            content: [
                'Entender la relevancia de los acuerdos matrimoniales, la residencia fiscal y la planificación tributaria en el manejo financiero.'
            ]
        },
        {
            moduleTitle: 'MÓDULO VII',
            title: 'Gobernanza, marco jurídico profesional y ética en las inversiones',
            content: [
                'Promover buenas prácticas de negocio y la importancia de la ética en las inversiones.'
            ]
        },
        {
            moduleTitle: 'MÓDULO VIII',
            title: 'Dólar, inflación y toma de decisiones',
            content: [
                'Analizar el impacto del dólar y la inflación en las decisiones financieras.',
                'Aprender a desarrollar un Plan de Negocios y gestionar proyectos de inversión de manera eficiente.'
            ]
        },
    ];

    return (
        <>
            {
                <ProgramBanner
                    title="Programa Introductorio en Finanzas y Gestión para Deportistas"
                    description={[
                        "Este curso está diseñado especialmente para deportistas profesionales, brindándoles los conocimientos necesarios para tomar decisiones financieras inteligentes tanto durante su carrera como después de su retiro.",
                        "Se abordarán de manera clara y sencilla los aspectos clave que todo deportista debe considerar para prolongar sus ingresos y mantener (o incluso mejorar) su calidad de vida en la etapa post-retiro."
                    ]}
                    video="HE6xuS0-WK4"
                    link="Finanzas-Gestion-Deportiva"
                    bgColor="green"
                />
            }
            {<ProgramSpecs programs={programs}/>}
            {<Goals goals={goals} bgColor="cream" />}
            {<LearningModule modules={modules} bgColor="green" />}
        </>
    );
};

export default ProgIntroFinGestDepor;